import React from 'react';
import { Create, NumberInput, ReferenceInput, SelectInput, SimpleForm, TextInput, required } from 'react-admin';
import { Wrapper } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const FuelCreate = (props) => {
    return (
        <Permission permission={PERMISSIONS.ADMIN}>
            <Wrapper>
                <Create title='Adicionar combustível' {...props}>
                    <SimpleForm sx={{ maxWidth: 600 }}>
                        <TextInput source="acronym" label="Sigla" maxLength="3" validate={required()} sx={{ minWidth: 300 }} />
                        <TextInput source="name" label="Nome" validate={required()} sx={{ minWidth: 300 }} />
                        <TextInput source="anpCode" label="Código ANP" sx={{ minWidth: 300 }} />
                        <NumberInput source="fuelType" label='Tipo do combustível (ConectTec)' sx={{ minWidth: 300 }} />
                        <ReferenceInput label="Combustível pai" source="parentFuelId" reference="parent-fuels">
                            <SelectInput optionText="name" sx={{ minWidth: 300 }} />
                        </ReferenceInput>
                    </SimpleForm>
                </Create>
            </Wrapper>
        </Permission>
    )
};

export default FuelCreate;
